import { ReviewType } from './Project';

/**
 * 项目进展审核状态枚举
 */
export enum ProgressReviewStatus {
  /** 待审核 */
  PENDING = 'PENDING',
  /** 已通过/已发布 */
  APPROVED = 'APPROVED',
  /** 已拒绝/被驳回 */
  REJECTED = 'REJECTED'
}

/**
 * 项目进展数据模型
 */
export interface ProjectProgress {
  /** 唯一标识 */
  id: string;
  
  /** 所属项目 ID */
  projectId: string;
  /** 项目名称（便于前端展示） */
  projectName?: string;
  
  /** 申请机构 ID */
  organizationId?: string;
  
  /** 进展标题 */
  title: string;
  
  /** 进展内容/进展说明（富文本） */
  content: string;
  
  /** 进展图片 URL 列表（最少1张，最多3张） */
  images: string[];
  
  /** 进展日期/公布时间 */
  progressDate: string;
  
  /** 审核状态 */
  reviewStatus: ProgressReviewStatus;
  
  /** 审核类型 */
  reviewType?: ReviewType;
  
  /** 审核意见（审核拒绝时） */
  reviewComment?: string;
  
  /** 审核时间 */
  reviewTime?: string;
  
  /** 审核人 ID */
  reviewerId?: string;
  
  /** 提交时间 */
  submitTime?: string;
  
  /** 创建时间 */
  createTime: string;
  
  /** 更新时间 */
  updateTime: string;
}

